import Vue from 'vue';
import { mapProperties } from '../../../helpers/helpers';

const state = {
  gcus: [],
  statusSupportedGCUs: [],
  gcuStatus: {},
  gcuAdvisorySubs: []
};

const getters = {
  getGCUNames: state => (site) => {
    if (state.gcus.length === 0) {
      return [];
    }
    if (site) {
      return state.gcus
        .filter(a => a.site_id === site)
        .map(mapProperties);
    }
    return state.gcus.map(mapProperties);
  },
  isGCUStatusSupported: state => (gcu) => {
    if (gcu) {
      const found = state.statusSupportedGCUs.find(gcuId => gcuId === gcu);
      if (found) return true;
    }

    return false;
  },
  getGCUStatus: state => (gcuId) => {
    if (gcuId) {
      return state.gcuStatus[gcuId];
    }

    return 'PENDING';
  }
};

const mutations = {
  setGCUs(state, gcuData) {
    const modGCUData = gcuData.map((a) => {
      a.timeFetched = null;
      return a;
    });
    state.gcus = modGCUData;
  },
  setStatusSupportedGCUs(state, gcu) {
    state.statusSupportedGCUs.push(gcu);
  },
  setGCUStatus(state, { id, status }) {
    Vue.set(state.gcuStatus, id, status);
  },
  clearGCUStatus(state) {
    state.gcuStatus = {};
  },
  setMultipleGCUStatus(state, status) {
    state.gcuStatus = Object.assign({}, state.gcuStatus, ...status);
  },
  setAdvisorySubs(state, subs) {
    state.gcuAdvisorySubs = subs;
  }

};

const actions = {
  async getGCUs({ state, commit, dispatch }, options) {
    if (state.gcus.length === 0) {
      const { gcus } = await this.$api.get('/v1/gcus', options);
      commit('setGCUs', gcus);
      dispatch('monitorGcuConnection');
      dispatch('getDeviceDefinition');
    }
  },
  // eslint-disable-next-line no-shadow
  async getDeviceDefinition({ getters, dispatch }) {
    if (!this.$broker.siteStatusQueue) {
      this.$broker.siteStatusQueue = this.$broker.genUserQueueName();
    }
    dispatch('broker/monitorSiteStatus', null, { root: true });
    getters.getGCUNames().forEach((gcu) => {
      this.$broker.sendGCUCommand('739', gcu.id, this.$broker.siteStatusQueue);
    });
  },
  async monitorGcuConnection({ state, commit }) {
    const { gcus } = state;
    let { advisorySubs } = state;

    if (state.length > 0) {
      advisorySubs.forEach(sub => this.$broker.unsubscribe(sub));
    }

    const pendingState = gcus.map(g => ({ [g.code]: 'PENDING' }));
    commit('setMultipleGCUStatus', pendingState);

    const initalGcusState = gcus.slice(0).map(g => ({ [g.code]: 'OFFLINE' }));
    let init = true;
    advisorySubs = await Promise.all(gcus.map(async (gcu) => {
      return this.$broker.subscribe(`/topic/ActiveMQ.Advisory.Consumer.Queue.${gcu.code}`, (msg) => {
        if (msg.headers.consumerCount > 0) {
          if (init){
            const [gcuState] = initalGcusState.filter(gS => Object.keys(gS)[0] === gcu.code);
            gcuState[gcu.code] = 'ONLINE';
          } else {
            commit('setGCUStatus', { id: gcu.code, status: 'ONLINE' });
          }
        }
      }).id;
    }));

    commit('setAdvisorySubs', advisorySubs);
    setTimeout(() => {
      init = false;
      commit('setMultipleGCUStatus', initalGcusState);
    }, process.env.VUE_APP_BROKER_TIMEOUT);
  },
  refreshGCUTrackers({ state }, gcus) {
    gcus.forEach((gcu) => {
      const found = state.statusSupportedGCUs.find(gcuId => gcuId === gcu);
      if (found) {
        this.$broker.sendGCUCommand('738', gcu, this.$broker.siteStatusQueue);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
